import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-primary-bg pt-20">
      <div className="container mx-auto px-6 py-12 max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-primary-cyan hover:text-primary-cyan/80 transition-colors mb-8"
        >
          <ArrowLeft size={20} />
          Back to Home
        </Link>

        <h1 className="text-3xl lg:text-4xl font-display font-bold text-white mb-6">
          Adatkezelési tájékoztató
        </h1>
        <p className="text-gray-400 leading-relaxed mb-8">
          Az alábbi dokumentum tartalmazza a Marvin AI Solutions Kft. adatkezelési tájékoztatóját,
          az elektronikus marketinges megkereséssel és a személyes adatok kezelésével kapcsolatos
          tájékoztatást.
        </p>

        <div className="rounded-lg border border-white/10 bg-primary-secondary/50 p-6">
          <h2 className="text-xl font-semibold text-white mb-4">Dokumentum letöltése</h2>
          <p className="text-gray-400 text-sm mb-4">
            A teljes, naprakész adatkezelési tájékoztató a következő dokumentumban olvasható:
          </p>
          <a
            href="/documents/adatkezelesi-tajekoztato.docx"
            download
            className="inline-flex items-center px-5 py-2.5 rounded-lg bg-primary-cyan text-primary-bg font-semibold hover:bg-primary-cyan/90 transition-colors"
          >
            Adatkezelési tájékoztató frissítése (DOCX)
          </a>
        </div>

        <p className="text-gray-500 text-sm mt-8">
          Kérdéseivel kapcsolatban keressen minket:{' '}
          <a href="mailto:info@marvinenergy.com" className="text-primary-cyan hover:underline">
            info@marvinenergy.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
